module.exports = __webpack_public_path__ + "static/toast-23fda74ea3dd8e7d7cfba26ed328c1ee.png";